import { render } from "./DigitalContentSection.vue?vue&type=template&id=6eb45d8c"
import script from "./DigitalContentSection.vue?vue&type=script&lang=js"
export * from "./DigitalContentSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__